import React from 'react'
import { get } from 'lodash-es'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'

import type { Comment } from '../../../../../redux-types'
import AvatarComponent from '../../../../components/AvatarComponent/AvatarComponent'
import CommentReactionFormatText from '../../../../components/CommentReactionFormatText/CommentReactionFormatText'
import ChatMessageLabelComponent from '../ChatMessageLabelComponent/ChatMessageLabelComponent'
import useFeatures from '../../../../hooks/useFeatures'

import './CommentInListComponent.scss'

const dateStyles = (
  style: { color: string; background: string } | undefined
) => ({
  color: style?.color ?? 'FFF',
  opacity: 0.8,
})

interface CommentInListComponentProps {
  item: Comment<'chat'>
  renderDelete: () => JSX.Element
  style?: {
    color: string
    background: string
  }
  styles: {
    readCommentStyle: {}
    unreadCommentStyle: {}
  }
  isUnread: boolean
}

const CommentInListComponent = ({
  item,
  renderDelete,
  style,
  styles,
  isUnread,
}: CommentInListComponentProps) => {
  const isSpeakerComment = item.label === 'Speaker'
  const { HasWebinarChatLinksEnabled } = useFeatures()

  return (
    <div
      className={classnames('comment-in-list-component', {
        'is-unread': isUnread,
      })}
      style={get(styles, `${isUnread ? 'un' : ''}readCommentStyle`)}
    >
      <div className="comment-author-avatar">
        <AvatarComponent
          imageSrc={item.avatar}
          name={item.truncated_name ?? item.name}
          size={32}
          shape="square"
          imageProps={{ type: 'background-contain' }}
        />
      </div>
      <div className="comment-content">
        <div className="comment-header">
          <span className="name">{item.name?.trim()}</span>
          {isSpeakerComment && (
            <div className="chat-message-label">
              <ChatMessageLabelComponent style={style}>
                <FormattedMessage defaultMessage="Speaker" />
              </ChatMessageLabelComponent>
            </div>
          )}
          <span className="date" style={dateStyles(style)}>
            {item.dateFormatted}
          </span>
          {renderDelete()}
        </div>
        <div className="comment-body">
          <CommentReactionFormatText>
            {HasWebinarChatLinksEnabled && isSpeakerComment
              ? item.content
              : item.content_text}
          </CommentReactionFormatText>
        </div>
      </div>
    </div>
  )
}

export default CommentInListComponent
